import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-footer',
  templateUrl: './irembogov-footer.component.html',
  styleUrls: ['./irembogov-footer.component.scss'],
})
export class IrembogovFooterComponent {}
